import { SEO } from "@/components/SEO";
import { useSettings } from "@/hooks/useData";
import { MaskedLines } from "@/components/motion/Reveal";

const Block = ({ title, children }) => (
  <div className="grid md:grid-cols-12 gap-6 border-t border-line py-10">
    <h2 className="md:col-span-4 display text-2xl text-ink">{title}</h2>
    <div className="md:col-span-8 text-base text-mute leading-relaxed flex flex-col gap-4">{children}</div>
  </div>
);

export default function Legal({ kind }) {
  const s = useSettings();
  const isImpressum = kind === "impressum";
  return (
    <>
      <SEO title={isImpressum ? "Impressum" : "Datenschutz"} description={isImpressum ? "Impressum der Emini Reinigung." : "Datenschutzerklärung der Emini Reinigung."} path={`/${kind}`} />
      <section className="bg-paper pt-36 md:pt-44 pb-28">
        <div className="container-x">
          <p className="label text-mute mb-8">Rechtliches</p>
          <MaskedLines as="h1" inView delay={0.2} lines={[isImpressum ? "Impressum." : "Datenschutz."]} data-testid="page-title" className="display text-5xl sm:text-6xl lg:text-7xl text-ink mb-20" />
          {isImpressum ? (
            <>
              <Block title="Verantwortlich">
                <p>{s?.company}<br />{s?.address_line1}<br />{s?.address_line2}<br />Schweiz</p>
                <p>Telefon: {s?.phone}<br />E-Mail: {s?.email}</p>
              </Block>
              <Block title="Handelsregister">
                <p>UID: <span className="text-ink">{s?.uid}</span></p>
              </Block>
              <Block title="Haftungsausschluss">
                <p>Die Inhalte dieser Website wurden mit Sorgfalt erstellt. Für Richtigkeit, Vollständigkeit und Aktualität übernehmen wir keine Gewähr. Haftungsansprüche wegen Schäden materieller oder immaterieller Art, die aus dem Zugriff oder der Nutzung der veröffentlichten Informationen entstehen, sind ausgeschlossen.</p>
              </Block>
              <Block title="Urheberrecht">
                <p>Die Urheber- und alle anderen Rechte an Inhalten, Bildern und Dateien auf dieser Website gehören ausschliesslich der Emini Reinigung oder den speziell genannten Rechteinhabern. Für die Reproduktion jeglicher Elemente ist die schriftliche Zustimmung der Urheberrechtsträger im Voraus einzuholen.</p>
              </Block>
            </>
          ) : (
            <>
              <Block title="Grundsatz">
                <p>Wir bearbeiten Personendaten nach dem Schweizer Datenschutzgesetz (DSG) und, soweit anwendbar, der DSGVO. Personendaten werden nur erhoben, wenn Sie uns diese freiwillig mitteilen, insbesondere über die Offertanfrage oder per E-Mail und Telefon.</p>
              </Block>
              <Block title="Offertanfrage">
                <p>Angaben aus der Offertanfrage (Objekt, Leistung, Ort, Kontaktdaten, optionale Fotos) verwenden wir ausschliesslich zur Bearbeitung Ihrer Anfrage und zur Erstellung einer Offerte. Die Daten werden auf gesicherten Servern gespeichert und nach Abschluss des Vorgangs gelöscht, sofern keine gesetzliche Aufbewahrungspflicht besteht.</p>
              </Block>
              <Block title="Server-Logdaten">
                <p>Beim Besuch dieser Website werden technische Daten wie IP-Adresse, Browsertyp, Datum und Uhrzeit des Zugriffs erfasst. Diese Daten dienen der Sicherheit und dem Betrieb der Website und werden nicht mit anderen Datenquellen zusammengeführt.</p>
              </Block>
              <Block title="Cookies und Analyse">
                <p>Diese Website verwendet technisch notwendige Cookies. Einsatz von Analyse-Tools: <span className="text-ink">[wird ergänzt]</span></p>
              </Block>
              <Block title="Ihre Rechte">
                <p>Sie haben das Recht auf Auskunft, Berichtigung, Löschung und Einschränkung der Bearbeitung Ihrer Personendaten. Wenden Sie sich dazu an {s?.email}.</p>
              </Block>
              <Block title="Verantwortliche Stelle">
                <p>{s?.company}<br />{s?.address_line1}<br />{s?.address_line2}<br />{s?.email}</p>
              </Block>
            </>
          )}
        </div>
      </section>
    </>
  );
}
